module.exports = {
    CARD: 'Card',
    TRANSFER: 'Transfer'
};
